import { NgModule } from '@angular/core';
import { AppWhiteLabelRule } from './rules/app.white-label-rule';
import { FactoringWhiteLabelRule } from './rules/factoring-white-label-rule';
import { SupplyChainDirectWhiteLabelRule } from './rules/supply-chain-direct-white-label-rule';
import { SupplyChainPlatformWhiteLabelRule } from './rules/supply-chain-platform-white-label-rule';
import { WhiteLabelManagerService } from './white-label-manager.service';
import { WHITE_LABEL_RULES } from './white-label-rule';

@NgModule({
    providers: [
        {
            provide: WHITE_LABEL_RULES,
            useClass: AppWhiteLabelRule,
            multi: true
        },
        {
            provide: WHITE_LABEL_RULES,
            useClass: SupplyChainDirectWhiteLabelRule,
            multi: true
        },
        {
            provide: WHITE_LABEL_RULES,
            useClass: SupplyChainPlatformWhiteLabelRule,
            multi: true
        },
        {
            provide: WHITE_LABEL_RULES,
            useClass: FactoringWhiteLabelRule,
            multi: true
        },
        WhiteLabelManagerService
    ]
})
export class WhiteLabelModule {}
